import { productCatalogGetProductImageUploadUrl } from '@repo/sdk'
import { createImageUploadHook } from './createImageUploadHook'

export const useProductImageUpload = createImageUploadHook(productCatalogGetProductImageUploadUrl)
